import Icon from "@core-components/icon/Icon";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { Group, Text } from "@mantine/core";
import AppSkeleton from "@modules/loader/AppSkeleton";
import { ReviewHelper } from "@modules/review/utils/Review.helper";

const ReviewBanner = () => {
  const { t } = useAppTranslation("common.reviews");
  return (
    <Group
      align="center"
      className="mx-2 rounded-xl bg-primary-darker p-3"
      gap={5}
      justify="center"
    >
      <Group className="hover-scale select-none" gap={3} justify="center">
        <Icon.TrustpilotStartFilled className="pr-3" size={35} />
        <AppSkeleton>
          <Text className="font-inter text-primary-white" fw={700}>
            {t("excellent")} {ReviewHelper.AVERAGE_GRADE}
          </Text>
        </AppSkeleton>
        <Text className="font-inter text-primary-white">{t("on")}</Text>
        <Text className="font-inter text-primary-white" fw={700}>
          Trustpilot
        </Text>
      </Group>
    </Group>
  );
};

export default ReviewBanner;
